import Vue from 'vue';
import Router from 'vue-router';
import layouts from '@/pages/layout/index.vue';
import login from '@/pages/login/login.vue';
import userManagement from '@/pages/AuthenticationAuthority/userManagement/index.vue';
import roleManagement from '@/pages/AuthenticationAuthority/roleManagement/index.vue';
import departmentManagement from '@/pages/AuthenticationAuthority/departmentManagement/index.vue';
import personBp from '@/pages/AuthenticationAuthority/personBp/index.vue';
import menuManagement from '@/pages/AuthenticationAuthority/menuManagement/index.vue';
import logManagementOfSys from '@/pages/AuthenticationAuthority/logManagementOfSys/index.vue';
import dictionaryManagement from '@/pages/systemManagement/dictionaryManagement/index.vue';

import messageManage from '@/pages/messageCenter/messageManage/index.vue';
import templateManage from '@/pages/messageCenter/templateManage/index.vue';
/**
 * 事项信息管理
 * start
 */
// 事项信息管理-待完善事项
import issuesManagement from '@/pages/baseInfo/issuesManagement/index.vue'
import elderlyPeopleLliving from '@/pages/baseInfo/elderlyPeopleLliving/index.vue'
import customEvent from '@/pages/baseInfo/customEvent/index.vue'

// 事项信息管理-待检查事项
import issuesStandardManagement from '@/pages/baseInfo/issuesStandardManagement/index.vue'

// 事项信息管理-已完结事项
import baseInfo from '@/pages/baseInfo/baseInfo/index.vue'
// 部件类型管理
import partsType from '@/pages/baseInfo/partsType/index.vue'
// 问题汇总分析
import problemAnalysis from '@/pages/problemAnalysis/index.vue'
// 上报问题统计分析
import reportproblemAnalysis from '@/pages/reportproblemAnalysis/index.vue'
// 关芯智巡大屏
import patrolScreen from '@/pages/patrolScreen/index.vue'
import patrolLargeScreen from '@/pages/patrolScreenMini/index.vue'
// 增加对比清单
import comparisonInspectionRecords from '@/pages/comparisonInspectionRecords/index.vue'
/**
 * 事项信息管理
 * end
 */
/**
 * 点位管理
 * start
 */
import motherChildPoint from '@/pages/point/motherChildPoint/index.vue'
import pointType from '@/pages/point/pointType/index.vue'
import pointEvent from '@/pages/point/pointEvent/index.vue'
import pointPerson from '@/pages/point/pointPerson/index.vue'
import pointParts from '@/pages/point/pointParts/index.vue'
/**
 * 点位管理
 * end
 */
/**
 * 任务管理
 * start
 */
import taskList from '@/pages/task/taskList/index.vue'
import longInspectionTask from '@/pages/task/longInspectionTask/index.vue'
import taskPlanMap from '@/pages/task/taskPlanMap/index.vue'
import patrolCalendar from '@/pages/task/patrolCalendar/index.vue'
import customTask from '@/pages/task/customTask/index.vue'
import requestHistory from '@/pages/requestHistory/index.vue'
import onDuty from '@/pages/onDuty/index.vue'
import standBy from '@/pages/standBy/index.vue'
import taskListData from '@/pages/task/taskListData/index.vue'
/**
 * 任务管理
 * end
 */
/**
 * 网格信息维护
 * start
 */
import blockOrganization from '@/pages/streetInfo/blockOrganization/index.vue'
import publicNotice from '@/pages/streetInfo/publicNotice/index.vue'
import message from '@/pages/streetInfo/message/index.vue'
import feedbacka from '@/pages/feedbacka/index.vue'
import feedbackb from '@/pages/feedbackb/index.vue'
import dkgj from '@/pages/dkgj/index.vue'
import errorApply from '@/pages/errorApply/index.vue'
/**
 * 网格信息维护
 * end
 */
/**
 * 应急任务管理
 * start
 */
import crashPlan from '@/pages/crashInfo/crashPlan/index.vue'
import crashPoint from '@/pages/crashInfo/crashPoint/index.vue'
import asylumSeekers from '@/pages/crashInfo/asylumSeekers/index.vue'
/**
 * 应急管理
 * end
 */
/**
 * 工作日记
 */
import gzrjIndex from '@/pages/gzrj/index.vue'
/**
 * 非日常上报
 */
import noPatrolReportIndex from '@/pages/noPatrolReport/index.vue'

// 商户打卡列表
import shClockList from '@/pages/mCheckInManage/shClockList/index.vue'
// 垃圾桶站打卡列表
import tzClockList from '@/pages/mCheckInManage/tzClockList/index.vue'
// 堆物堆料打卡列表
import dwdlClockList from '@/pages/mCheckInManage/dwdlClockList/index.vue'
// 事项指标管理
import sxzbManage from '@/pages/mCheckInManage/sxzbManage/index.vue'

// 掌上海淀权限跳转
import forbidden from '@/pages/forbidden/index.vue'

// 文化积淀管理
import culturalManage from '@/pages/culturalManage/index.vue'

// 人员标签管理
import personLabel from '@/pages/personLabel/index.vue'

// 居民互动
import jmhdIndex from '@/pages/jmhd/index.vue'

//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: '/login'
    },
    {
      path: "/login",
      name: "登录",
      component: login,
    },
    {
      name: "关芯智巡大屏",// 关芯智巡大屏
      path: "/patrolScreen",
      component: patrolScreen
    },
    {
      name: "关芯智巡大屏",// 关芯智巡大屏
      path: "/patrolLargeScreen",
      component: patrolLargeScreen
    },
    {
      path: "/Portal",
      name: "首页",
      component: layouts,
      children: [

        {
          name: "userManagement",// 认证权限-用户管理
          path: "/userManagement",
          component: userManagement
        }, {
          name: "personBp",// 认证权限-人员包片管理
          path: "/personBp",
          component: personBp
        }, {
          name: "roleManagement",// 认证权限-角色管理
          path: "/roleManagement",
          component: roleManagement
        }, {
          name: "departmentManagement",// 认证权限-部门管理
          path: "/departmentManagement",
          component: departmentManagement
        }, {
          name: "menuManagement",// 认证权限-菜单管理
          path: "/menuManagement",
          component: menuManagement
        },
        {
          name: "logManagementOfSys", // 认证权限-日志管理
          path: "/logManagementOfSys",
          component: logManagementOfSys
        },

        {
          name: "dictionaryManagement",// 系统管理-字典管理
          path: "/dictionaryManagement",
          component: dictionaryManagement
        },
        {
          name: "issuesManagement",// 事项管理
          path: "/issuesManagement",
          component: issuesManagement
        },
        {
          name: "issuesStandardManagement",// 事项标准管理
          path: "/issuesStandardManagement",
          component: issuesStandardManagement
        },
        {
          name: "partsType",// 部件类型管理
          path: "/partsType",
          component: partsType
        },
        {
          name: "baseInfo",// 事项信息管理-已完结事项
          path: "/baseInfo",
          component: baseInfo
        },
        {
          name: "motherChildPoint",// 母子点位管理
          path: "/motherChildPoint",
          component: motherChildPoint
        },
        {
          name: "pointEvent",// 点位事项管理
          path: "/pointEvent",
          component: pointEvent
        },
        {
          name: "pointPerson",// 点位人员管理
          path: "/pointPerson",
          component: pointPerson
        },
        {
          name: "pointParts",// 点位部件管理
          path: "/pointParts",
          component: pointParts
        },
        {
          name: "pointType",// 点位类型管理
          path: "/pointType",
          component: pointType
        },
        {
          name: "requestHistory",// 上报历史
          path: "/requestHistory",
          component: requestHistory
        },
        {
          name: "onDuty",// 上报历史
          path: "/onDuty",
          component: onDuty
        },
        {
          name: "standBy",// 上报历史
          path: "/standBy",
          component: standBy
        },
        {
          name: "messageManage",// 消息中心-消息管理
          path: "/messageManage",
          component: messageManage
        },
        {
          name: "templateManage",// 消息中心-模板管理
          path: "/templateManage",
          component: templateManage
        },

        {
          name: "taskList",// 任务管理
          path: "/taskList",
          component: taskList
        },
        {
          name: "longInspectionTask",// 长期巡查任务
          path: "/longInspectionTask",
          component: longInspectionTask
        },
        {
          name: "taskListData",// 任务清单数据
          path: "/taskListData",
          component: taskListData
        },
        {
          name: "customTask",// 长期巡查任务
          path: "/customTask",
          component: customTask
        },
        {
          name: "taskPlanMap",// 任务计划地图
          path: "/taskPlanMap",
          component: taskPlanMap
        },
        {
          name: "patrolCalendar",// 巡逻日历管理
          path: "/patrolCalendar",
          component: patrolCalendar
        },
        {
          name: "blockOrganization",// 网格信息维护
          path: "/blockOrganization",
          component: blockOrganization
        },
        {
          name: "publicNotice",// 事项公示管理
          path: "/publicNotice",
          component: publicNotice
        },
        {
          name: "message",// 网格长留言管理
          path: "/message",
          component: message
        },
        {
          name: "crashPlan",// 应急计划管理
          path: "/crashPlan",
          component: crashPlan
        },
        {
          name: "crashPoint",// 应急点位管理
          path: "/crashPoint",
          component: crashPoint
        },
        {
          name: "asylumSeekers",// 应急避难人员登记
          path: "/asylumSeekers",
          component: asylumSeekers
        },
        {
          name: "problemAnalysis",// 问题汇总分析
          path: "/problemAnalysis",
          component: problemAnalysis
        },
        {
          name: "reportproblemAnalysis",// 上报问题统计分析
          path: "/reportproblemAnalysis",
          component: reportproblemAnalysis
        },
        {
          name: "elderlyPeopleLliving",// 孤寡老人基本管理
          path: "/elderlyPeopleLliving",
          component: elderlyPeopleLliving
        },
        {
          name: "customEvent",// 孤寡老人基本管理
          path: "/customEvent",
          component: customEvent
        },
        {
          name: "comparisonInspectionRecords",// 孤寡老人基本管理
          path: "/comparisonInspectionRecords",
          component: comparisonInspectionRecords
        },
        {
          name: "feedbacka",// 留言反馈
          path: "/feedbacka",
          component: feedbacka
        },
        {
          name: "feedbackb",// 留言反馈
          path: "/feedbackb",
          component: feedbackb
        },
        {
          name: "dkgj",// 打卡轨迹
          path: "/dkgj",
          component: dkgj
        },
        {
          name: "errorApply",// 错题审核
          path: "/errorApply",
          component: errorApply
        },
        {
          name: "gzrjIndex",// 工作日记
          path: "/gzrjIndex",
          component: gzrjIndex
        },
        {
          name: "noPatrolReportIndex",// 非日常上报
          path: "/noPatrolReportIndex",
          component: noPatrolReportIndex
        },
        // 商户打卡列表
        {
          name: "shClockList",
          path: "/shClockList",
          component: shClockList
        },
        // 商户打卡列表
        {
          name: "tzClockList",
          path: "/tzClockList",
          component: tzClockList
        },
        // 堆物堆料打卡列表
        {
          name: "dwdlClockList",
          path: "/dwdlClockList",
          component: dwdlClockList
        },
        // 事项指标管理
        {
          name: "sxzbManage",
          path: "/sxzbManage",
          component: sxzbManage
        },
        // 文化积淀管理
        {
          name: "culturalManage",
          path: "/culturalManage",
          component: culturalManage
        },
        // 人员标签管理
        {
          name: "personLabel",
          path: "/personLabel",
          component: personLabel
        },
        // 居民互动
        {
          name: "jmhdIndex",
          path: "/jmhdIndex",
          component: jmhdIndex
        }
      ]
    },
    {
      name: "跳转掌上海淀",// 关芯智巡大屏
      path: "/forbidden",
      component: forbidden
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js